// src/drunkSongRoulette.ts
// Drunk Song Roulette – frontend entry point

async function loadCSV(url: string): Promise<string[]> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const text = await res.text();
  return text
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0 && !line.startsWith("#") && line !== "title" && line !== "voice");
}

function spinSlot(
  el: HTMLElement,
  items: string[],
  winner: string,
  totalDuration: number,
  onComplete: () => void
): void {
  el.classList.add("spinning");
  el.classList.remove("spin-complete");

  let elapsed = 0;
  let interval = 40;

  const tick = () => {
    el.textContent = items[Math.floor(Math.random() * items.length)];
    elapsed += interval;

    if (elapsed < totalDuration) {
      const progress = elapsed / totalDuration;
      interval = 40 + progress * progress * 460;
      setTimeout(tick, interval);
    } else {
      el.textContent = winner;
      el.classList.remove("spinning");
      el.classList.add("spin-complete");
      onComplete();
    }
  };

  setTimeout(tick, interval);
}

document.addEventListener("DOMContentLoaded", async () => {
  let songs: string[] = [];
  let voices: string[] = [];

  const spinBtn = document.getElementById("spinBtn") as HTMLButtonElement;
  const songDisplay = document.getElementById("songDisplay") as HTMLElement;
  const voiceDisplay = document.getElementById("voiceDisplay") as HTMLElement;
  const resultEl = document.getElementById("result") as HTMLElement;
  const songError = document.getElementById("songError") as HTMLElement;
  const voiceError = document.getElementById("voiceError") as HTMLElement;

  // Load CSV data
  try {
    songs = await loadCSV("/assets/songs.csv");
  } catch {
    songs = ["Hallelujah", "Free Fallin'", "Let It Be", "Wonderwall", "Africa"];
    songError.classList.remove("hidden");
  }

  try {
    voices = await loadCSV("/assets/voices.csv");
  } catch {
    voices = ["Kermit the Frog", "Donald Duck", "Yourself", "Mickey Mouse", "Yoda"];
    voiceError.classList.remove("hidden");
  }

  // Seed displays with first items
  songDisplay.textContent = songs[0] ?? "?";
  voiceDisplay.textContent = voices[0] ?? "?";

  spinBtn.textContent = "🎲 Spin!";
  spinBtn.disabled = false;

  let spinning = false;

  spinBtn.addEventListener("click", () => {
    if (spinning || songs.length === 0 || voices.length === 0) return;

    spinning = true;
    spinBtn.disabled = true;
    resultEl.textContent = "";
    resultEl.classList.add("hidden");
    songDisplay.classList.remove("spin-complete");
    voiceDisplay.classList.remove("spin-complete");

    const song = songs[Math.floor(Math.random() * songs.length)];
    const voice = voices[Math.floor(Math.random() * voices.length)];

    let doneCount = 0;

    const onBothDone = () => {
      doneCount++;
      if (doneCount === 2) {
        resultEl.textContent = `🎵 Sing "${song}" as ${voice}!`;
        resultEl.classList.remove("hidden");
        spinning = false;
        spinBtn.disabled = false;
      }
    };

    spinSlot(songDisplay, songs, song, 2200, onBothDone);
    spinSlot(voiceDisplay, voices, voice, 2700, onBothDone);
  });
});
